import Vue from 'vue';

// 关闭当前tags页签并返回上一页
Vue.prototype.$closeAndGoBack = function () {
  this.$store.commit('DEL_TAG', this.$store.getters.tag);
  const tagList = this.$store.getters.tagList;
  const lastTag = this.$store.getters.tagList[tagList.length - 1] ?? {};
  this.$router.push({
    path: this.$router.$avueRouter.getPath({
      name: lastTag.label,
      src: lastTag.value,
    }),
    query: lastTag.query,
  });
};

// 关闭当前tags页签
Vue.prototype.$closePage = function () {
  this.$store.commit('DEL_TAG', this.$store.getters.tag);
};
